<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6">
                {{year}} ©  TAMWILCOM - Tous droits réservés.
            </div>
            <div class="col-sm-6">
                <div class="text-sm-end d-none d-sm-block">
                    Nouveau Socle
                </div>
            </div>
        </div>
    </div>
</footer>
